/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { ReportAverageWeeklyHours } from './ReportAverageWeeklyHours';
import {
    ReportAverageWeeklyHoursFromJSON,
    ReportAverageWeeklyHoursFromJSONTyped,
    ReportAverageWeeklyHoursToJSON,
    ReportAverageWeeklyHoursToJSONTyped,
} from './ReportAverageWeeklyHours';

/**
 * 
 * @export
 * @interface ListAverageWeeklyHoursReportsResponse
 */
export interface ListAverageWeeklyHoursReportsResponse {
    /**
     * 
     * @type {Array<ReportAverageWeeklyHours>}
     * @memberof ListAverageWeeklyHoursReportsResponse
     */
    data: Array<ReportAverageWeeklyHours>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListAverageWeeklyHoursReportsResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListAverageWeeklyHoursReportsResponse interface.
 */
export function instanceOfListAverageWeeklyHoursReportsResponse(value: object): value is ListAverageWeeklyHoursReportsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListAverageWeeklyHoursReportsResponseFromJSON(json: any): ListAverageWeeklyHoursReportsResponse {
    return ListAverageWeeklyHoursReportsResponseFromJSONTyped(json, false);
}

export function ListAverageWeeklyHoursReportsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListAverageWeeklyHoursReportsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ReportAverageWeeklyHoursFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListAverageWeeklyHoursReportsResponseToJSON(json: any): ListAverageWeeklyHoursReportsResponse {
      return ListAverageWeeklyHoursReportsResponseToJSONTyped(json, false);
  }

  export function ListAverageWeeklyHoursReportsResponseToJSONTyped(value?: ListAverageWeeklyHoursReportsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(ReportAverageWeeklyHoursToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

